module.exports = __webpack_public_path__ + "img/134ne.258879ed.svg";